import { AppEffects } from './app.effect';

export const effects: any[] = [AppEffects];

export * from './app.effect';